import { TW_NotificationDefault } from "@utils/twClasses";
import { useMemo } from "react";
import { useModelStore } from "src/store";

interface NotificationProps {
  number: number | null;
  twClasses?: string;
}

export function Notification({ number, twClasses }: NotificationProps) {
  const wsColor = useModelStore((state) => state.wsColor);
  const style = useMemo(() => {
    return {
      backgroundColor: wsColor,
    }
  }, [wsColor]);
  return (
    <div className={TW_NotificationDefault + " " + twClasses} style={style}>{(number) ? number : ""}</div>
  )
}